import { IAppointment } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";
import { IAppointmentResponse } from "@modules/eirCustomersFacade/interfaces/responses/IAppointmentResponse";

export const mapAppointment = (response: IAppointmentResponse): IAppointment => ({
    id: response.id,
    status: response.status,
    installationType: response.installationType,
    scheduledDate: response.scheduledDate ?? "",
    timeSlot: response.timeSlot,
});
